import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useFormSubmit } from "./useFormSubmit";
import { useTransformValues } from "./useTransformValues";
import { useAdaptedVehiclesFields } from "./useAdaptedVehiclesFields";

import { fetchVehiclesFields } from "../slices/vehiclesCreateSlice";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";

export const useVehiclesCreateForm = () => {
    const dispatch = useDispatch();
    const formId = "vehicles";
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);
    const reload = true;
    const { transformFormValues } = useTransformValues();

    useEffect(() => {
        dispatch(fetchVehiclesFields({token}))
    }, [dispatch, token]);

    const adaptedFieldList = useAdaptedVehiclesFields()
    const fields = adaptedFieldList.flatMap(category => category.fields);

    const removeEmpty = (obj) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => {
                if (value === undefined || value === null) return false;
                if (Array.isArray(value) && value.length === 0) return false;
                if (typeof value === "string" && value.trim() === "") return false;

                return true;
            })
        );
    };

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const rawAttributes = transformFormValues(formValues, fields);
            const attributes = removeEmpty(rawAttributes);

            const body = {
                data: {
                    type: "vehicles",
                    attributes: attributes
                }
            };

            console.log("Отправляемые данные", body);

            const action = await dispatch(sendForm({url: "/vehicles", body, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    return { formId, loadingStatus, handleSend: handleSubmit, adaptedFieldList }
}